import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  h2 {
    margin-bottom: 2.5rem;
    width: 100%;
  }

  &.pcma-faq-section {
    h2 {
      text-align: center;
    }
  }
`;

export const Article = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 3rem;
  width: 100%;

  * {
    &:last-child {
      margin-bottom: 0;
    }
  }

  ${ContentWrapper}.pcma-faq-section & {
    width: 100%;
    border-bottom: 1px solid ${themeGet('colors.border-grey')};
    padding-bottom: 30px;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 85%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 80%;
    }
  }

  h3 {
    font-size: 1.125rem;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.5rem;
      line-height: 2rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 2rem;
      line-height: 2.5rem;
    }
  }

  p,
  ol,
  ul,
  li {
    font-size: 1rem;
    line-height: 2rem;
  }

  p {
    margin-bottom: 1.5rem;
  }

  div {
    p,
    ul,
    ol {
      margin-bottom: 1rem;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  ol,
  ul {
    padding-left: 0.75rem;
  }
`;

export const Ctas = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  a {
    margin: 1rem 1rem;
  }
`;
